import React from "react";
import { Input } from "../../../../../components/ui/input";
import { X, Plus } from "lucide-react";
import { BaseFieldPreviewProps } from "./previewUtils";
import {
	handleAddOption,
	handleRemoveOption,
	handleOptionLabelChange,
} from "./previewUtils";

const ChipsFieldPreview: React.FC<BaseFieldPreviewProps> = ({
	field,
	renderDescription,
	onUpdateOptions,
	onUpdateField,
}) => {
	if (!field.options) return null;

	const canRemove = field.options.length > 2;

	return (
		<div>
			{renderDescription()}
			<div className="flex flex-wrap gap-2 items-center">
				{field.options.map((option: string, index: number) => (
					<div
						key={`option-${index}`}
						className="flex items-center gap-1 rounded-full border border-gray-300 bg-gray-50 pl-3 pr-1 py-0.5"
					>
						{onUpdateOptions ? (
							<Input
								value={option}
								onChange={(
									e: React.ChangeEvent<HTMLInputElement>
								) =>
									handleOptionLabelChange(
										index,
										e.target.value,
										field.options!,
										onUpdateOptions
									)
								}
								className="h-7 border-0 bg-transparent px-0 min-w-[60px] focus-visible:ring-0 focus-visible:ring-offset-0 shadow-none"
								style={{
									width: `${Math.max(
										60,
										option.length * 8 + 16
									)}px`,
								}}
								aria-label={`Chip-Option ${
									index + 1
								} bearbeiten`}
								data-testid={`chip-option-input-${index}`}
							/>
						) : (
							<span className="text-sm text-gray-700">
								{option}
							</span>
						)}
						{onUpdateOptions && (
							<button
								onClick={() =>
									handleRemoveOption(
										index,
										field.options!,
										onUpdateOptions
									)
								}
								disabled={!canRemove}
								className="text-gray-400 hover:text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed p-1 rounded-full"
								aria-label={`Chip-Option ${
									index + 1
								} entfernen`}
								data-testid={`remove-chip-option-${index}`}
							>
								<X className="h-3 w-3" />
							</button>
						)}
					</div>
				))}

				{field.allowOther && (
					<div className="flex items-center gap-1 rounded-full border border-gray-300 bg-gray-100 pl-3 pr-1 py-0.5 text-sm text-gray-600">
						<span>Sonstiges (Kurzantwort)</span>
						{onUpdateField && (
							<button
								onClick={() =>
									onUpdateField({ allowOther: false })
								}
								className="text-gray-400 hover:text-gray-600 p-1 rounded-full"
								aria-label="Sonstiges-Option entfernen"
								data-testid="remove-sonstiges-chip"
							>
								<X className="h-3 w-3" />
							</button>
						)}
					</div>
				)}

				{onUpdateOptions && (
					<button
						onClick={() =>
							handleAddOption(field.options!, onUpdateOptions)
						}
						className="flex items-center gap-1 rounded-full border border-dashed border-gray-300 px-3 py-1 text-sm text-gray-500 hover:border-gray-400 hover:bg-gray-50"
						aria-label="Chip-Option hinzufügen"
						data-testid="add-chip-option"
					>
						<Plus className="h-3 w-3" />
						Option
					</button>
				)}

				{!field.allowOther && onUpdateField && (
					<button
						onClick={() => onUpdateField({ allowOther: true })}
						className="flex items-center gap-1 rounded-full border border-dashed border-blue-300 px-3 py-1 text-sm text-blue-600 hover:border-blue-400 hover:bg-blue-50"
						aria-label="Sonstiges-Option hinzufügen"
						data-testid="add-sonstiges-chip"
					>
						<Plus className="h-3 w-3" />
						„Sonstiges"
					</button>
				)}
			</div>
		</div>
	);
};

export default ChipsFieldPreview;
